import { DependencyList, EffectCallback, useEffect, useState } from "react";

import { DebounceSettings } from "lodash";

import useDebounce from "./useDebounce";

/**
 * Runs the function when the dependencies change, but debounced so that the
 * function only runs when the dependencies stop changing for a time. Note that
 * the effect won't run on first render.
 */
export default function useDebouncedEffect(
  fn: EffectCallback,
  dependencies: DependencyList,
  wait?: number,
  options?: DebounceSettings
): void {
  const [deps, _setDeps] = useState<DependencyList>(dependencies);
  const setDeps = useDebounce(_setDeps, wait, options);

  // Update `deps` when dependencies change. `setDeps` is debounced so this
  // hopefully updates `deps` when dependencies stop changing for a time.
  useEffect(() => {
    setDeps(dependencies);
  }, dependencies);

  // Run the function when debounced `deps` finally changes.
  useEffect(fn, deps);
}
